import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import { SEARCH } from 'constants/filter-sets';
import { actionsForFilterSet, FILTER_WRITE_ACTIONS } from 'redux/modules/filtersets';
import { isLoggedIn } from 'redux/modules/user';
import { filterSetFilters, filterSetFilterValue } from 'redux/saga/selectors';
import { deepExtract } from 'helpers/deep';
import { isPresent } from 'helpers/verify';
import { VERTICALS, FILTER_NAMES, CREDITS_FILTER_MIN_CREDITS, CREDITS_FILTER_MAX_CREDITS } from '../Search.constants';
export var searchFilterActions = actionsForFilterSet(SEARCH);
export var makeWriteFilterSetSelector = function makeWriteFilterSetSelector(filterSet) {
  return function (action) {
    return FILTER_WRITE_ACTIONS.includes(action.type) && deepExtract('data.filterSetId', action) === filterSet && !deepExtract('data.options.excludeFromWriteActions', action) // TODO - remove this in favor of a new action type that will be excluded from write actions
    ;
  };
};
export var selectSearchFilterWriteActions = makeWriteFilterSetSelector(SEARCH);
export var selectSearchFilters = function selectSearchFilters(state) {
  return filterSetFilters(state, SEARCH);
};
export var selectSearchFilterValue = function selectSearchFilterValue(state, filter) {
  return filterSetFilterValue(state, SEARCH, filter);
};
export var initializeMultiSelectFromHash = function initializeMultiSelectFromHash(keys, filtersFromHash) {
  return (// Due to the way multi-select filters are implemented in store, we can only include keys that are filtered
    keys.reduce(function (acc, amenityKey) {
      if (filtersFromHash[amenityKey]) {
        if (!acc) {
          acc = {};
        }

        acc[amenityKey] = true;
      }

      return acc;
    }, null)
  );
};
export var getCreditsFilterDisplayValues = function getCreditsFilterDisplayValues(creditsRange) {
  return [// Using isPresent to avoid unexpected behavior with 0
  creditsRange && isPresent(creditsRange.low) ? creditsRange.low : CREDITS_FILTER_MIN_CREDITS, creditsRange && isPresent(creditsRange.high) ? creditsRange.high : CREDITS_FILTER_MAX_CREDITS];
};
export var getCreditsFilterValue = function getCreditsFilterValue(low, high) {
  // Using isPresent to avoid unexpected behavior with 0
  // omit low value if less than or equal to the minimum
  var filterLowValue = isPresent(low) && low > CREDITS_FILTER_MIN_CREDITS ? low : null; // omit high value if greater than or equal to the maximum

  var filterHighValue = isPresent(high) && high < CREDITS_FILTER_MAX_CREDITS ? high : null; // return null if neither value is present to allow 'filtered' flag to be set appropriately in reducer

  return isPresent(filterLowValue) || isPresent(filterHighValue) ? _objectSpread({}, isPresent(filterLowValue) && {
    low: filterLowValue
  }, isPresent(filterHighValue) && {
    high: filterHighValue
  }) : null;
};
export var getDefaultVerticalId = function getDefaultVerticalId(state) {
  return isLoggedIn(state) ? VERTICALS.fitness : VERTICALS.all;
};
export var selectResultType = function selectResultType(state) {
  return selectSearchFilterValue(state, FILTER_NAMES.RESULT_TYPE);
};
export var selectSelectedVertical = function selectSelectedVertical(state) {
  return selectSearchFilterValue(state, FILTER_NAMES.VERTICAL) || getDefaultVerticalId(state);
}; // return null if there is no selected range to allow 'filtered' flag to be set appropriately in reducer

export var selectSelectedCreditsRange = function selectSelectedCreditsRange(state) {
  return selectSearchFilterValue(state, FILTER_NAMES.CREDITS) || null;
};
export var creditsRangeShape = PropTypes.shape({
  low: PropTypes.number,
  high: PropTypes.number
});